<template>
  <div>
  <div v-if="loadingPatientProfile" class="overlay">
    <div style="width: 100%; margin-top: 12em;">
      <p style="font-size: 1em; font-weight: bold;">Fetching Resident...</p>
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem !important;"></i>
    </div>
  </div>
  <div class="view" style="margin-left: 40px">
    <!-- MAIN VIEW -->
    <!-- PRESCRIBER VIEW -->
    <div
      v-if="$store.state.userType == 'prescriber'"
      class="view dashboard-view prescriber-dashboard table-container"
      style="background-color: transparent; box-shadow: none; width: 95.5vw; padding: 0; margin: 0;">
      <div class="prescriber-patient-panel panel" style="margin-right: 20px; width: 60vw">
        <h3 class="panel-header">Patients</h3>
        <PatientPrescriber :patients="patients" @loadPatientProfile="loadPatientProfile" @loadPrescriberPatients="loadPrescriberPatients" :facilities="facilities" :loading="loading" />
      </div>
      <div class="prescriber-cr-panel panel">
        <h3 class="panel-header">Chart Reviews</h3>
        <ChartReviews :patients="patients" :loading="loading" />
      </div>
      <!-- <div class="prescriber-rmmrs-panel panel" >
        <h3>RMMRS</h3>
        <div class="dashboard-container"></div>
      </div> -->
      <!-- <div class="prescriber-anti-panel panel" >
        <h3>Residents on Antipsychotics</h3>
        <ResidentsOnDrug />
      </div> -->
      <!-- <div class="prescriber-reports-panel panel" >
        <h3>Reports</h3>
        <div class="dashboard-container"></div>
      </div> -->
    </div>
    <!-- PHARMACY VIEW -->
    <div
      v-if="$store.state.userType == 'pharmacy'"
      class="view dashboard-view pharmacy-dashboard table-container"
      style="background-color: white; box-shadow: none; padding: 35px 25px;">
      <div class="panel" style="width: 308px">
        <!-- <h3>Resident Search</h3> -->
        <PatientPharmacy :patients="filteredPatients" @loadPharmacyPatients="loadPharmacyPatients" :facilities="facilities" :loading="loading"/>
      </div>
      <div class="panel">
        <!-- <h3>Task log</h3> -->
        <PharmacyLog :patients="filteredPatients" :loadingPatients="loading" @facilityFilter="facilityFilter" :facilities="facilities"  />
      </div>
    </div>

  <ErxOnboardingModal v-if="showErxOnboardingModal" :prescriberId="erxOnboardingPrescriberId"
    @close="closeErxOnboardingModal" />

  <WarehouseDetails v-if="$store.state.userType == 'warehouse'"/>
  
  <!-- AMBULANCE VIEW -->
  <div
    v-if="$store.state.company && $store.state.company.type == 'ambulance'"
    class="view dashboard-view"
    style="background-color: transparent; box-shadow: none; width: 95.5vw; padding: 0; margin: 0; display: grid; grid-template-columns: 1fr 1fr; grid-gap: 20px;">
    <div class="panel" style="background-color: white; border-radius: 12px; box-shadow: 0px 0 5px -2px rgb(155, 155, 155); display: flex; flex-direction: column; overflow: hidden; height: 85vh;">
      <h3 class="panel-header" style="background-color: #1bc5ea; color: white; padding: 10px 20px; margin: 0; font-size: 1.2rem; display: flex; justify-content: space-between; align-items: center;">
        <span>Checked Out Bags</span>
        <button class="blue-button" style="margin: 0; padding: 6px 15px; font-size: 0.85rem;" @click="$refs.checkedOutBagsRef.showCheckoutModal = true">New Bag Checkout</button>
      </h3>
      <div style="flex: 1; overflow-y: auto; background-color: white;">
        <CheckedOutBags ref="checkedOutBagsRef" />
      </div>
    </div>
    <div class="panel" style="background-color: white; border-radius: 12px; box-shadow: 0px 0 5px -2px rgb(155, 155, 155); display: flex; flex-direction: column; overflow: hidden; height: 85vh;">
      <h3 class="panel-header" style="background-color: #0e7de3; color: white; padding: 10px 20px; margin: 0; font-size: 1.2rem; display: flex; justify-content: space-between; align-items: center;">
        <span>Clinician Holds</span>
        <button class="blue-button" style="margin: 0; padding: 6px 15px; font-size: 0.85rem; border: 1px solid white;" @click="$refs.clinicianHoldsRef.showCheckoutModal = true">New Clinician Hold</button>
      </h3>
      <div style="flex: 1; overflow-y: auto; background-color: white;">
        <ClinicianHolds ref="clinicianHoldsRef" />
      </div>
    </div>
  </div>

  </div>
  </div>
</template>

<script>
// @ is an alias to /src
import PatientPrescriber from '../components/dashboard/PatientPrescriber.vue';
import PatientPharmacy from '../components/dashboard/PatientPharmacy.vue';
import ChartReviews from '../components/dashboard/ChartReviews.vue';
// import ResidentsOnDrug from '../components/dashboard/ResidentsOnDrug.vue';
import PharmacyLog from '../components/dashboard/PharmacyLog.vue';
import axios from 'axios';
import WarehouseDetails from '../components/dashboard/WarehouseDetails.vue';
import CheckedOutBags from '../components/dashboard/CheckedOutBags.vue';
import ClinicianHolds from '../components/dashboard/ClinicianHolds.vue';
import ErxOnboardingModal from '../components/modals/ErxOnboardingModal.vue';
import { daysUntil } from '@/services/dates';

export default {
  name: 'Home',
  components: {
    PatientPrescriber,
    PatientPharmacy,
    ChartReviews,
    // ResidentsOnDrug,
    PharmacyLog,
    WarehouseDetails,
    CheckedOutBags,
    ClinicianHolds,
    ErxOnboardingModal
  },
  data() {
    return {
      loading: false,
      patients: [],
      filteredPatients: [],
      prescriber: false,
      facilities: [],
      pharmacy: true,
      loadingPatientProfile: false,
      showErxOnboardingModal: false,
      erxOnboardingPrescriberId: null,
      erxOnboardingChecked: false,
    }
  },
  methods: {
    facilityFilter(facilitiesFilter){
      if(facilitiesFilter.length){
        this.filteredPatients = this.patients.filter(patient => facilitiesFilter.includes(patient.location?.location?.facility?.uuid));
      } else {
        this.filteredPatients = this.patients
      }
    },
    loadPharmacyPatients(value) {
      if (value) {
        this.loading = true;
        console.log('loading pharmacy patients now');
        this.$store.dispatch('getRefreshToken');
        this.patients = [];
        this.facilities =[];
        axios.post('/get-pharmacy-residents', { name: null }, this.$store.state.header).then(res => {
          this.loading = false;
          // Sort facility names (keys) to ensure stable order
          const sortedFacilities = Object.keys(res.data).sort();
          
          sortedFacilities.forEach(key => {
            res.data[key].forEach(patient=>{
              patient.facility = key;
              this.patients.push(patient);
              if(patient.location?.location?.facility?.uuid) {
                this.facilities.push({
                  id: patient.location.location.facility.uuid,
                  name: patient.location.location.facility.name,
                });
              }
            })
          })
          this.filteredPatients = this.patients
          // One entry was pushed per resident above, so a facility with five residents appeared
          // five times in the picker. `new Set` deduped nothing: each iteration builds a fresh
          // object literal, and Set compares objects by reference. Key on the uuid instead.
          this.facilities = [...new Map(this.facilities.map(facility => [facility.id, facility])).values()];
        })
      }
    },
    loadPrescriberPatients(value) {
      if (value) {
        this.loading = true;
        console.log('loading prescriber patients now');
        this.$store.dispatch('getRefreshToken');
        this.patients = [];
        this.facilities =[];
        axios.post('/get-prescriber-residents', { name: null, facility_id: null }, this.$store.state.header).then(res => {
          this.loading = false;
          // Sort facility names (keys) to ensure stable order
          const sortedFacilities = Object.keys(res.data).sort();

          sortedFacilities.forEach(key => {
            this.facilities.push(key);
            res.data[key].forEach(patient=>{
              patient.facility = key;
              
              // Check for erx_chart expiry
              if (patient.erx_chart && patient.erx_chart.end_date) {
                  const diffDays = daysUntil(patient.erx_chart.end_date);

                  if (diffDays !== null) {
                      if (!patient.alerts) {
                          patient.alerts = [];
                      }

                      if (diffDays < 0) {
                          patient.alerts.push("Chart Expired");
                      } else if (diffDays <= 14) {
                          patient.alerts.push("Chart Expiring");
                      }

                      // Inject into global alerts panel
                      if (diffDays <= 14) {
                          const firstName = patient.personal_information?.first_name || '';
                          const lastName = patient.personal_information?.last_name || '';
                          const fullName = `${firstName} ${lastName}`.trim() || 'Unknown Resident';
                          
                          this.$store.commit('addAlert', {
                              id: `client_alert_chart_expiry_${patient.uuid}`,
                              channel: 'alert_approaching_chart_expiry',
                              subject: {
                                  uuid: patient.uuid,
                                  type: 'chart_expiry',
                                  deleted_at: null
                              },
                              body: {
                                  title: 'Medication Order Expiry',
                                  message: `${fullName}||1||${diffDays}||chart`
                              },
                              read: false
                          });
                      }
                  }
              }

              this.patients.push(patient);
            })
          })
        })
      }
    },
    loadPatientProfile(value) {
      this.loadingPatientProfile = true;
    },
    checkErxOnboarding() {
      // Only relevant for prescribers, and only checked once per mount (guards
      // against the store's user watcher elsewhere re-triggering this).
      if (this.erxOnboardingChecked || this.$store.state.userType !== 'prescriber') {
        return;
      }
      this.erxOnboardingChecked = true;

      const personId = JSON.parse(localStorage.getItem('user_id'));
      if (!personId) {
        return;
      }

      axios.get(`/person/${personId}/get-prescriber-details`, this.$store.state.header).then(res => {
        const details = res.data || {};
        const needsOnboarding = !details.erx_onboarding_completed_at
          && (!details.erx_entity_id_set || !details.erx_nash_cert_uploaded);

        if (needsOnboarding) {
          this.erxOnboardingPrescriberId = personId;
          this.showErxOnboardingModal = true;
        }
      }).catch(err => {
        console.error('Error checking ePrescribing onboarding status:', err);
      });
    },
    closeErxOnboardingModal() {
      this.showErxOnboardingModal = false;
    }
  },
  mounted() {
    this.checkErxOnboarding();
  }
}
</script>

<style lang="scss">
@import "../assets/css/main.scss";

.prescriber-dashboard {
  display: grid !important;
  grid-gap: 5px;
  background-color: white;
  padding: 10px 10px;
  border-radius: 12px;
  box-shadow: 0px 0 5px -2px rgb(155, 155, 155);
  height: 90vh;

  div {
    padding: 3px;

    p {
      margin: 0;
    }

    border-radius: 12px;
  }

  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;

}

.prescriber-patient-panel {
  grid-column-start: 1;
  grid-column-end: 12;
  grid-row-start: 1;
  grid-row-end: 3;
}

.prescriber-cr-panel {
  grid-column-start: 12;
  grid-column-end: 19;
  grid-row-start: 1;
  grid-row-end: 3;
  margin-right: 0 !important;
}

// .prescriber-rmmrs-panel{
//   grid-column-start: 14;
//   grid-column-end: 19;
//   grid-row-start: 1;
//   grid-row-end: 1;
// }

.prescriber-anti-panel {
  grid-column-start: 1;
  grid-column-end: 5;
  grid-row-start: 2;
  grid-row-end: 2;
}

.prescriber-reports-panel {
  grid-column-start: 5;
  grid-column-end: 19;
  grid-row-start: 2;
  grid-row-end: span 2;
}

.dashboard-view {
  .panel {
    h4 {
      margin: 0;
      text-align: left;
      padding-left: 20px;
    }

    .dashboard-container {
      border-radius: 12px;
      background-color: white;
      height: 92%;
      box-shadow: 0px 0 5px -2px rgb(155, 155, 155);
    }
  }
}

.pharmacy-dashboard {
  width: 95vw !important;
  display: grid !important;
  grid-gap: 5px;
  background-color: white;
  padding: 10px 10px;
  border-radius: 12px;
  box-shadow: 0px 0 5px -2px rgb(155, 155, 155);
  height: 90vh;

  div {
    padding: 3px;

    p {
      margin: 0;
    }

    border-radius: 12px;
  }

  grid-template-columns: 308px 3fr;

}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(128, 128, 128, 0.5); /* Gray background with transparency */
  z-index: 1000; /* Ensure it appears above other content */
  pointer-events: none; /* Allow clicks to pass through if not used correctly */
}

/* Optional: Ensure content below the overlay is unclickable */
.overlay::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(128, 128, 128, 0.5); /* Gray overlay */
  pointer-events: auto; /* Make the overlay block interactions */
  z-index: 999; /* Place above other content but below the overlay */
}
</style>